import React, { useMemo, useState, useCallback } from "react";
import { useDispatch } from "react-redux";
import { Button, Modal, ModalBody, ModalFooter } from "reactstrap";
import i18next from "i18next";
import ScanNowBtn from "components/BarcodeScanner/button.jsx";
import ScanSettings from "components/ScanSettings";
import ScanDetails from "containers/BarcodeScannerContainer/ScanDetailsContainer.jsx";
import { resetScanLogs } from "actions/StockModal/barcodeScanningActions.js";
import { resetQuantityGrid } from "actions/quantityGridActions";
import {
  trackAnalyticsEvent,
  buyplanOrReleaseRecord,
  buyplanContext
} from "apis/analyticsHelpers.js";

const BarcodeScannerContainer = ({
  isAdminUser,
  isTemplate,
  isAgentAdmin,
  isMarketingrelease,
  handleBarcodeSubmit,
  isStockModel,
  releaseId,
  confirmedBuyplanId,
  // Only populated on a CnF/SuperFill render (StockModalLayout) — a
  // StockModel has no buyplanState of its own, so smType alone decides
  // buyplan_type there.
  stockModalId,
  buyplanState,
  smType,
}) => {
  const dispatch = useDispatch();
  const [isScanning, setIsScanning] = useState(false);
  const [lastScannedBarcode, setLastScannedBarcode] = useState("");

  const showScannerModeBtn = useMemo(() => {
    if (isAdminUser || isTemplate) return false;
    if (isAgentAdmin && isMarketingrelease) return false;
    return true;
  }, [
    isAdminUser,
    isTemplate,
    isAgentAdmin,
    isMarketingrelease,
  ]);

  const [isModalOpen, setModalOpen] = useState(false);
  const openModal = () => {
    setModalOpen(true);
    dispatch(resetQuantityGrid())

    if (confirmedBuyplanId || releaseId || stockModalId) {
      trackAnalyticsEvent("range_page_action", {
        category: "Scan Now",
        ...buyplanOrReleaseRecord(confirmedBuyplanId, releaseId),
        ...buyplanContext(confirmedBuyplanId, stockModalId, buyplanState, smType),
        path: window.location.pathname
      });
    }
  }
  const closeModal = () => {
    setLastScannedBarcode("")
    setModalOpen(false);
    window.location.reload(); 
  };

  const resetScannerLogs = () => {
    dispatch(resetScanLogs());
  };

  const successCallbackFn = useCallback(
    (barcode, lastScannedBarcode) => {
      handleBarcodeSubmit(barcode, lastScannedBarcode)

      setLastScannedBarcode(barcode)
    },[]
  );

  const [isCameraScan, setIsCameraScan] = useState(false);
  const [isManualMode, setIsManualMode] = useState(!isStockModel);

  const setScanType = (evt) => {
    setIsCameraScan(evt.target.value === "cameraScanner");
    dispatch(resetQuantityGrid())
    dispatch(resetScanLogs())
  };

  const setScanMode = (evt) => {
    setIsManualMode(evt.target.value === "manualMode");
    dispatch(resetQuantityGrid())
    dispatch(resetScanLogs())
  };

  return (
    showScannerModeBtn && (
      <>
        <ScanNowBtn onClick={openModal} className="btn" type="button" >
          {i18next.t("buttons.scanNow")}
        </ScanNowBtn>

        {isModalOpen && (
          <Modal
            className={"modal-container mw-100 w-75"}
            isOpen={isModalOpen}
            toggle={closeModal}
            onExit={resetScannerLogs}
            backdrop={true}
            centered
            autoFocus={false}
          >
            <ModalBody className="w-100">
              <div className="d-flex justify-content-between mt-2">
                <h6>Barcode Scanning</h6>

                <Button onMouseDown={closeModal} color="primary">
                  Exit
                </Button>
              </div>
              <hr />
              <ScanSettings
                setScanType={setScanType}
                isCameraScan={isCameraScan}
                setScanMode={setScanMode}
                isManualMode={isManualMode}
                isStockModel={isStockModel}
                isScanning={isScanning}
                setIsScanning={setIsScanning}
                successCallbackFn={successCallbackFn}
                lastScannedBarcode={lastScannedBarcode}
              />
              <hr />
              <ScanDetails
                isManualMode={isManualMode}
              />
            </ModalBody>
            <ModalFooter className="mt-4"></ModalFooter>
          </Modal>
        )}
      </>
    )
  );
};

export default React.memo(BarcodeScannerContainer);
